import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, Image, ScrollView, TextInput, View } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { social_getArticleFeedById, social_searchArticles } from '../../store/actionsv1/social';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import { ArticleFeedProps, ArticleProps } from '../../store/types/soc_svc';
import ArticleCard from './components/ArticleCard';
import StreamCard from './components/StreamCard';

const ArticlesScreen = ({ route, navigation }:any) => {
    const [ loading, setLoading ] = useState(false);
    const [ stream, setStream ] = useState<{url:string, stream_type:string} | undefined>()
    const [ search_value, setSearchValue ] = useState('')
    const [ header_height, setHeaderHeight ] = useState(0);

    const dispatch = useDispatch();
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const app_size:{width:number, height:number} = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
    const articles:ArticleProps[] = useSelector((state:any) => state.social.stored_articles.filter((a:ArticleProps) => a.article_feed_id == route.params.article_feed_id), (left, right) => left.length == right.length)
    const article_feed:ArticleFeedProps | undefined = useSelector((state:any) => state.social.stored_article_feeds.find((af:ArticleFeedProps) => af.article_feed_id == route.params.article_feed_id), (left, right) => left?.article_feed_id == right?.article_feed_id)

    useEffect(() => {
        if(!route.params.article_feed_id){ return }
        getArticlesFromServer(0)
        getArticleFeedFromServer()
    },[route.params.article_feed_id])

    useEffect(() => {
        if(!article_feed){ return }
        if(article_feed.is_live && article_feed.live_stream_url){
            setStream({ url:article_feed.live_stream_url, stream_type:article_feed.live_stream_type })
        }
    },[ article_feed?.article_feed_id ])

    const getArticleFeedFromServer = async() => {
        await dispatch(social_getArticleFeedById(route.params.article_feed_id))
    }

    const getArticlesFromServer = async(offset:number) => {
        setLoading(true)
        await dispatch(social_searchArticles(search_value, offset, route.params.article_feed_id))
        setLoading(false)
    }

    const handleSearch = () => {
        getArticlesFromServer(0)
    }

    const handleArticlePress = (article:ArticleProps) => {
        switch(article.article_type){
            case 'video': return setStream({ url:article.url, stream_type:article.video_type })
            default: return window.open(article.url, '_blank')
        }
        
    }


    const renderArticles = (data:{ item:ArticleProps, index:number }) => {
        return (
            <View style={{ margin:10 }}>
                <ArticleCard truncate_title maxWidth={app_size.width / 2.5} article={data.item} width={app_size.width / 2.5} onArticlePress={(article) => handleArticlePress(article)}/>
            </View>
        )
    }

    if(!article_feed){
        return (
            <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight}/>
            </View>
        )
    }

    const live_visible = stream?.url == article_feed.live_stream_url ? true : false
    let feed_image = article_feed.feed_image?.url
    if(!feed_image || feed_image === ''){
        feed_image = require('../../assets/images/default_feed.webp')
    }
    return (
        <View style={{ flex:1 }}>
            <ScrollView style={{ flex:1 }}>
                <View nativeID="viewing-feed">
                    {stream ?
                    <StreamCard width={app_size.width} stream_type={stream.stream_type} url={stream.url} onHeightChange={(height:number) => setHeaderHeight(height)}/>
                    :
                    <Image source={feed_image} style={{ width:app_size.width, height:app_size.height / 3 }} resizeMode='cover' />
                    }
                </View>
                <View style={{ minHeight:app_size.height, backgroundColor:Colors.shades.white, padding:10 }}>
                    <View style={{ flexDirection:'row', alignItems:'center', padding:10, paddingRight:20, paddingLeft:20 }}>
                        <View style={{ flexDirection:'row', flex:1, backgroundColor:Colors.shades.white, borderRadius:22, borderWidth:1, borderColor:Colors.brand.electric }}>
                            <Icon containerStyle={{ alignSelf:'center', padding:10 }} name='search' type='feather' color={Colors.brand.electric} size={18} />
                            <TextInput style={{ flex:1, fontFamily:'barlow-regular', fontSize:14, color:Colors.brand.midnight, padding:5}} 
                            value={search_value}
                            placeholder={`Search ${article_feed.feed_name} articles...`}
                            onChangeText={(text) => setSearchValue(text)}/>
                        </View>
                        <TouchableOpacity style={{ padding:5, marginLeft:10 }} onPress={() => handleSearch()}>
                            <Text size={14} color={Colors.brand.electric} weight='semibold'>Search</Text>
                        </TouchableOpacity>
                    </View>
                    <View style={{ justifyContent:'center', alignItems:'center' }}>
                        <FlatList numColumns={2} data={articles} renderItem={renderArticles} keyExtractor={(item) => item.article_id.toString()}/>
                    </View>
                </View>
                {!article_feed.claim_status || article_feed.claim_status === 'open' ?
                <View style={{ position:'absolute', justifyContent:'center', alignItems:'center', top:40, right:0, left:0}}>
                    <TouchableOpacity style={{ flexDirection:'row', backgroundColor:Colors.shades.white, padding:10, borderRadius:22 }} onPress={() => console.log('claim!')}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold' style={{ marginRight:5 }}>Claim This News Feed</Text>
                        <Icon name='check' type='feather' size={16} color={Colors.brand.slate}/>
                    </TouchableOpacity>
                </View>
                :article_feed.claim_status === 'requested' && article_feed.company_id == player?.player_id ?
                <View style={{ position:'absolute', justifyContent:'center', alignItems:'center', top:40, right:0, left:0, padding:10}}>
                    <View style={{ backgroundColor:Colors.brand.cyan, padding:10, borderRadius:22 }}>
                        <Text size={14} color={Colors.shades.white} weight='bold' style={{ marginRight:5 }}>Claim Requested</Text>
                        <View style={{ marginTop:10 }}>
                            <Text size={12} color={Colors.shades.white}>We will notify you if any additional information is required to process claim.  Once claimed, this podcast will be attached to your profile</Text>
                        </View>
                   </View>
                </View>
                :<></>}
            </ScrollView>
            {!live_visible && article_feed.live_stream_url ?
                <TouchableOpacity style={{ position:'absolute', bottom:20, right:20, justifyContent:'center', alignContent:'center', borderRadius:100, padding:10, backgroundColor:Colors.brand.electric,  shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }} 
                onPress={() => setStream({ url:article_feed.live_stream_url, stream_type:'iframe' })}> 
                    <Text size={16} color={Colors.shades.white} weight='bold'>Go Live</Text>
                </TouchableOpacity>
            :<></>}
            
        </View>
    )
}

export default ArticlesScreen